import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_traderbot.png",
      alt: "Estratégias TraderBot",
    },
    title: "Valorize seus investimentos",

    // String ou array de strings
    text: "Nossas estratégias são desenvolvidas e testadas para que você tenha a tranquilidade e segurança para escolher a que mais se adequar ao seu perfil.",
    testimonial: {
      text: "Nossa Prioridade é estar em constante evolução dos nossos produtos.",
      author: {
        name: "Marcelo Hoepfner, CEO TraderBot Inteligência Financeira",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "TraderBot Inteligência Financeira",
    heading: "Confira as nossas estratégias de day trade",
    subtitle: "Estratégias desenvolvidas por profissionais. Com controle de risco e performance.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a TraderBot.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A TraderBot",
    col1: [
      "A TraderBot é uma das empresas pioneiras no desenvolvimento de estratégias automatizadas, desde 2015, disponibilizando mais de 50 estratégias totalmente parametrizáveis, fomos sempre destaque pela transparência e confiabilidade dos nossos produtos.",
      "Com destaque para o nosso suporte, sempre auxiliando em todas as dúvidas, trazendo assim segurança e tranquilidade para o investidor, desde o iniciante até o avançado.",
    ],
    col2: [
      "É com esta premissa que estamos sempre buscando desenvolver os melhores algoritmos, prestando o melhor atendimento, excelentes ferramentas e funcionalidades que fazem da TraderBot o destaque no uso de estratégias automatizadas.",
    ],
  },

  stats: {
    title: "Alguns dos nossos números nesses 7 anos",
    subtitle:
      "A TraderBot é uma das empresas pioneiras no desenvolvimento de algoritmos para negociações automatizadas.",
    data: [
      {
        value: "+7k",
        description: "Clientes Atendidos",
      },
      {
        value: "+38k",
        description: "Estratégias utilizadas",
      },
      {
        value: "+12 Anos",
        description: "Atuando no mercado financeiro",
      },
      {
        value: "+7 Anos",
        description: "Desenvolvendo Algoritmos",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da TraderBot?",
    subtitle: "Veja quais as principais vantagens dos robôs da TraderBot.",
    data: [
      {
        icon: iconsSet.growth,
        title: "Anos de experiência no mercado",
        description:
          "Nossas estratégias são desenvolvidas por profissionais que atuam a mais de 12 anos no mercado e com a experiência de atendimento de clientes no Brasil e no mundo a mais de 7 anos.",
      },
      {
        icon: iconsSet.tune,
        title: "Controle de risco em tempo real",
        description:
          "O controle de risco é feito em tempo real pelo próprio robô, analisando a movimentação do ativo e do mercado, ajustando os alvos e buscando somente as melhores operações.",
      },
      {
        icon: iconsSet.play_2,
        title: "Praticidade e Simplicidade",
        description:
          "É muito simples começar seus investimentos automatizados. É só escolher nossas estratégias e dar um play!",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade através do nosso suporte humanizado, proporcionando uma experiência exclusiva.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a plataforma opere por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description:
          "Muitas vezes agimos de maneira emocional e impulsiva em nossos investimentos. Com as estratégias automatizadas você não terá esse problema!",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
